import 'react-datepicker/dist/react-datepicker.css';
import '@/styles/datepicker.css';

import { ButtonProps } from '@chakra-ui/react';
import ja from 'date-fns/locale/ja';
import React, { forwardRef } from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';

import { CmButton } from '@/components/uiParts';
registerLocale('ja', ja);

interface Props extends ReactDatePickerProps {
  selectedDate?: Date;
  isError?: boolean;
  dateFormat?: 'yyyy - MM - dd';
  onChange: (date: Date) => void;
}

interface CustomButtonProps extends ButtonProps {
  isError?: boolean;
}

const CustomButton = forwardRef<HTMLButtonElement, CustomButtonProps>(
  function CustomInputButton({ value, isError, onClick }, ref) {
    return (
      // @ts-ignore TS2590
      <CmButton
        fontSize="large"
        borderColor={isError ? '#E53E3E' : 'rgb(226, 232, 240)'}
        borderWidth={isError ? '2px' : '1px'}
        fontWeight="normal"
        color="black"
        variant="outline"
        {...{ onClick, ref }}
      >
        {value}
      </CmButton>
    );
  }
);

export const CmButtonDatePicker: React.FC<Props> = ({
  selectedDate,
  timeIntervals = 5,
  dateFormat = 'yyyy/MM/dd',
  isError = false,
  onChange,
  ...rest
}) => {
  return (
    <ReactDatePicker
      selected={selectedDate}
      onChange={onChange}
      locale="ja"
      {...{ ...rest, dateFormat, timeIntervals }}
      customInput={<CustomButton {...{ isError }} />}
    />
  );
};
